import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {finalize} from 'rxjs';
import {ErrorResponse} from 'src/app/api/model/common/error-response.model';
import {EmailContactService} from 'src/app/api/module/erp/services/email/email-contact-service';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';
import {CaptchaComponent} from 'src/app/pages/area-logada/shared/components/captcha/captcha.component';

@Component({
  selector: 'app-email-contact',
  templateUrl: './email-contact.component.html',
  styleUrls: ['./email-contact.component.scss'],
})
export class EmailContactComponent implements OnInit, AfterViewInit {
  public formGroupEmailContact!: UntypedFormGroup;

  isLoading: boolean = false;
  formSubmitted: boolean = false;
  isSendEmail: boolean = true;
  captchaToken: string | null = null;
  @ViewChild('captcha') captcha: CaptchaComponent;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private emailContactService: EmailContactService,
    private toastr: ToastrService,
    private _spinnerService: SpinnerService,
  ) {}

  ngOnInit(): void {
    this.criarForm();
  }

  private criarForm() {
    this.formGroupEmailContact = this.formBuilder.group({
      name: ['', Validators.required, Validators.maxLength(10)],
      email: new UntypedFormControl(null, [
        Validators.required,
        Validators.pattern('^[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}$'),
      ]),
      phone: ['', [Validators.maxLength(14)]],
      message: ['', [Validators.required, Validators.maxLength(150)]],
    });
  }

  isFormValid() {
    this.formSubmitted = true;
    return this.formGroupEmailContact.invalid;
  }

  ngAfterViewInit(): void {
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }
  onSubmit() {
    if (!this.captchaToken) {
      this.toastr.error('Por favor, complete o CAPTCHA antes de enviar.', 'Aviso');
      return;
    }
    if (this.isFormValid()) return;

    try {
      this.iniciarSpinner();
      this.isSendEmail = false;
      this.isLoading = true;
      this.emailContactService
        .onSendEmailComplice(this.formGroupEmailContact.value, this.captchaToken)
        .pipe(
          finalize(() => {
            this.pararSpinner();
          }),
        )
        .subscribe(
          () => {
            this.toastr.success('E-mail enviado Sucesso!');
            this.formGroupEmailContact.reset();
            this.isLoading = false;
            this.formSubmitted = false;
            this.captchaToken = null;
            this.captcha.reset();
            this.isSendEmail = false;
            this.isLoading = false;
          },

          (erro: ErrorResponse) => {
            this.toastr.error('Não foi possível enviar o E-mail.', 'Aviso!');
            this.pararSpinner();
            this.isLoading = false;
          },
        );
    } catch (error) {
      this.pararSpinner();
      this.captchaToken = null;
      this.captcha.reset();
      this.isLoading = false;
      this.toastr.error('Não foi possível enviar o E-mail, estamos trabalhando resolver a instabilidade', 'Aviso');
    }
  }

  iniciarSpinner() {
    this._spinnerService.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }
}
